import {Component, OnInit} from '@angular/core';
import {
  DomainPageSettings,
  DomainSettingKey,
} from '@gatewee/types/domain-setting';
import {SettingsService} from '@gatewee/services/core/settings.service';

@Component({
  selector: 'app-links',
  templateUrl: './app-links.component.html',
  standalone: false,
})
export class AppLinksComponent implements OnInit {
  page: DomainPageSettings | null = null;
  readonly year = new Date().getFullYear();

  constructor(private readonly settingsService: SettingsService) {}

  ngOnInit(): void {
    this.page = this.settingsService.get(
      'branding',
      DomainSettingKey.PAGE,
    ) as DomainPageSettings | null;
  }

  get termsUrl(): string | undefined {
    const url = this.page?.assets?.termsOfService?.trim();
    return url || undefined;
  }

  get privacyUrl(): string | undefined {
    const url = this.page?.assets?.privacyPolicy?.trim();
    return url || undefined;
  }

  /** Full copyright string from domain settings when configured. */
  get copyrightLine(): string | null {
    const c = this.page?.footer?.copyright?.trim();
    return c ? c : null;
  }

  get siteTitle(): string {
    return this.page?.title?.trim() ?? '';
  }
}
